<template>
  <div class="fileBox" @click="handleClick">
    <div class="icon_file"></div>
    <span>{{ files.length }}个附件</span>
  </div>
</template>

<script>
export default {
  props: ["files"],
  methods: {
    handleClick() {
      console.log("handleClick", this.files);
      this.$emit("handleClick", this.files);
    }
  }
};
</script>

<style lang="scss" scoped>
.fileBox {
  color: #c3c3c3;
  font-size: 16px;
  display: flex;
  cursor: pointer;
  .icon_file {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_file.png") no-repeat;
    background-size: cover;
    width: 36px;
    height: 36px;
    margin-right: 9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FilePreview.vue